import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

export default function NyTeknikerTidArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <p>
                            Skal du have en tekniker på besøg men er blevet forhindret i at være hjemme på dagen?
                            Vi kan ændre tiden for dig, hvis du kontakter os senest 48 timer før besøget.
                        </p>
                        <p>
                            Så kan vi nå at finde et nyt tidspunkt til dig, og du undgår at blive opkrævet et gebyr på 699 kr. for et forgæves teknikerbesøg.
                        </p>
                        <p><strong>
                            Hvis du ønsker at få en ny teknikertid, skal du ringe til os eller henvende dig på vores chat.
                            Find kontakt og åbningstider <Link to={Routing.Contact.Index}>her</Link>.
                        </strong></p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvornår kommer teknikeren?</h2>
                        <p>
                            Du har fået en mail hvor du kan se tidsrummet for teknikerbesøget.
                        </p>
                        <p>
                            Vi kan desværre ikke give dig det præcise tidspunkt &ndash; det afhænger nemlig af teknikernes rute på dagen.
                        </p>
                        <ul className="list list--bullet">
                            <p>
                                Teknikeren kan komme hjem til dig i følgende tidsrum:
                            </p>
                            <li><p>
                                <strong>Heldagsaftale:</strong> mellem kl. 07.30-16.00.
                            </p></li>
                            <li><p>
                                <strong>Halvdagsaftale:</strong> mellem kl. 07.30-12.00 eller 12.00-16.00.
                            </p></li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Teknikeren ringer 30 minutter før</h2>
                        <ul className="list list--bullet">
                            <li><p>
                                Du får et opkald 30 minutter før teknikeren er på din adresse, så du er sikker på at være hjemme.
                            </p></li>
                            <li><p>
                                Teknikeren ringer på nummeret, du har oplyst i forbindelse med bestillingen af dit abonnement.
                            </p></li>
                            <li><p>
                                Hvis du ikke besvarer opkaldet, kører teknikeren stadig til din adresse.
                            </p></li>
                            <li><p>
                                Teknikeren kan ringe fra hemmeligt nummer.
                            </p></li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Skal jeg være hjemme, når teknikeren kommer?</h2>
                        <ul className="list list--bullet">
                            <li><p>
                                Der skal være en myndig person på adressen til at tage imod teknikeren.
                            </p></li>
                            <li><p>
                                Det må gerne være en anden myndig person end den, hvis navn der står i bestillingen.
                            </p></li>
                        </ul>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Er du ikke hjemme, når teknikeren kommer?</h2>
                        <ul className="list list--bullet">
                            <li><p>
                                Så vil du blive opkrævet et gebyr på 699 kr. for et forgæves teknikerbesøg.
                            </p></li>
                            <li><p>
                                Det er derfor vigtigt, at du er på adressen i tidsrummet og besvarer teknikerens opkald.
                            </p></li>
                        </ul>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "leveringstid",
                        "name": "Leveringstid på internet"
                    },
                    {
                        "category": "bestilling",
                        "article": "opsig-eksisterende-abonnement",
                        "name": "Skal jeg selv opsige mit eksisterende abonnement?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    }
                ]}
            />
        </>
    )
}
